import { render } from "./ElementUI.vue?vue&type=template&id=e666f170&ts=true"
import script from "./ElementUI.vue?vue&type=script&lang=ts"
export * from "./ElementUI.vue?vue&type=script&lang=ts"

import "./ElementUI.vue?vue&type=style&index=0&id=e666f170&lang=scss"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__